import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function Map({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Map</title>
      <path
        d="M19.6838 3.43874L19.4466 2.72723L19.6838 3.43874ZM9.89443 18.4472L9.55902 19.118L9.89443 18.4472ZM4.44721 20.2764L4.1118 19.6056L4.44721 20.2764ZM3.68377 4.77208L3.4466 4.06056L3.68377 4.77208ZM2.25 5.72076V19.382H3.75V5.72076H2.25ZM4.78262 20.9472L8.44098 19.118L7.77016 17.7764L4.1118 19.6056L4.78262 20.9472ZM9.55902 19.118L13.7702 21.2236L14.441 19.882L10.2298 17.7764L9.55902 19.118ZM16.2298 21.2236L20.7826 18.9472L20.1118 17.6056L15.559 19.882L16.2298 21.2236ZM21.75 17.382V4.38743H20.25V17.382H21.75ZM19.4466 2.72723L15.3953 4.07767L15.8696 5.50069L19.9209 4.15026L19.4466 2.72723ZM14.6047 4.07767L9.86963 2.49931L9.39528 3.92233L14.1304 5.50069L14.6047 4.07767ZM8.13037 2.49931L3.4466 4.06056L3.92094 5.48359L8.60472 3.92233L8.13037 2.49931ZM9.86963 2.49931C9.30514 2.31114 8.69486 2.31114 8.13037 2.49931L8.60472 3.92233C8.8613 3.8368 9.1387 3.8368 9.39528 3.92233L9.86963 2.49931ZM15.3953 4.07767C15.1387 4.1632 14.8613 4.1632 14.6047 4.07767L14.1304 5.50069C14.6949 5.68886 15.3051 5.68886 15.8696 5.50069L15.3953 4.07767ZM21.75 4.38743C21.75 3.19295 20.5798 2.3495 19.4466 2.72723L19.9209 4.15026C20.0828 4.09629 20.25 4.21679 20.25 4.38743H21.75ZM20.7826 18.9472C21.3755 18.6508 21.75 18.0448 21.75 17.382H20.25C20.25 17.4767 20.1965 17.5632 20.1118 17.6056L20.7826 18.9472ZM13.7702 21.2236C14.5444 21.6107 15.4556 21.6107 16.2298 21.2236L15.559 19.882C15.2071 20.0579 14.7929 20.0579 14.441 19.882L13.7702 21.2236ZM8.44098 19.118C8.79289 18.9421 9.20711 18.9421 9.55902 19.118L10.2298 17.7764C9.45564 17.3893 8.54436 17.3893 7.77016 17.7764L8.44098 19.118ZM2.25 19.382C2.25 20.6829 3.61905 21.529 4.78262 20.9472L4.1118 19.6056C3.94558 19.6887 3.75 19.5678 3.75 19.382H2.25ZM3.75 5.72076C3.75 5.61315 3.81886 5.51762 3.92094 5.48359L3.4466 4.06056C2.732 4.29876 2.25 4.96751 2.25 5.72076H3.75Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M15 5V20.5"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 4L9 18"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
